import {actionNames} from 'constant/index';
const mapDispatchToProps = dispatch => ({
    INFORMATION_OP_SET_DATA: (dataOP)=> dispatch(
        { "type":actionNames.INFORMATION_OP_SET_DATA,
        "state": {"dataOP":dataOP } 
        }
    )
});
export default mapDispatchToProps;